<template>
  <div>
    <slot :booking="booking">
      <div class="d-flex align-items-center">
        <div class="mr-auto">
          <small class="text-uppercase d-md-block text-secondary">{{ $t('Product') }}:</small>
          <h5 class="font-weight-bold mb-0">{{ booking.equipment.product.name }}</h5>
          <span class="text-muted">{{ booking.equipment.product.brand.name }} - </span>
          <span class="text-muted">
            {{ booking.equipment.size ? `${booking.equipment.size}` : '' }}
            {{ booking.equipment.color && booking.equipment.size ? ' - ' : '' }}
            {{ booking.equipment.color ? `${booking.equipment.color}` : '' }}
          </span>
        </div>
        <img :src="booking.equipment.product.image" width="80" class="img-fluid mr-3" :alt="booking.equipment.product.name">
      </div>
      <div class="mt-3">
        <div class="d-flex flex-wrap">
          <div class="mt-3" style="min-width: 200px">
            <small class="text-uppercase d-md-block text-secondary">{{ $t('Start Date of Reservation') }} :</small>
            <h5 class="font-weight-bold mb-0">{{ dayjs(booking.start_at).format('LLLL') }}</h5>
          </div>
          <div class="mt-3" style="min-width: 200px">
            <small class="text-uppercase d-md-block text-secondary">{{ $t('End Date of Reservation') }} :</small>
            <h5 class="font-weight-bold mb-0">{{ dayjs(booking.end_at).format('LLLL') }}</h5>
          </div>
        </div>
      </div>
      <div v-if="booking.booking_slot?.stage" class="mt-3">
        <span class="text-uppercase d-md-block text-secondary">{{ $t('Stage') }}:</span>
        <h5 class="font-weight-bold mb-0">{{booking.booking_slot.stage.name}}</h5>
      </div>
      <div v-if="booking.store" class="mt-3">
        <span class="text-uppercase d-md-block text-secondary">{{ $t('Store') }}:</span>
        <h5 class="font-weight-bold mb-0">{{ booking.store.name }}</h5>
      </div>
      <div v-if="location" class="mt-3">
        <span class="text-uppercase d-md-block text-secondary">{{ $t('Location') }}:</span>
        <h5 class="font-weight-bold mb-0">{{ location.name }}</h5>
        <p class="text-muted d-block">
          {{ location.address }}
        </p>
        <MapWithSingleMarker :position="{
              lat : location.latitude,
              lng : location.longitude
            }"
           class="mt-3"
           style="height:200px"
        >
        </MapWithSingleMarker>
      </div>
    </slot>
  </div>
</template>

<script>
import {formatDateRange} from "@/utils/date";
import dayjs from "dayjs";
import MapWithSingleMarker from "@/components/atoms/map/MapWithSingleMarker.vue";
export default {
  name: "BookingInformation",
  components: {
    MapWithSingleMarker
  },
  props: {
    booking: {
      type: Object,
      required: true
    },
  },
  computed: {
    dayjs() {
      return dayjs;
    },
    location() {
      return this.booking.booking_slot?.stage?.location || this.booking.store?.location || null;
    }
  },
  methods: {
    formatDateRange,
    onClickCancel() {
      this.$emit('clickCancel');
    }
  },
}
</script>

<style scoped>

</style>